import type { BadgeVariant } from '../../components/ui/Badge';
import type { KhoaDich } from '../../i18n';
import type { LoiTenVaiTro } from './nghiep-vu/vai-tro-nen-tang';
import type { NhomQuyenNenTang } from './types';

/**
 * Nhãn phân hệ trong cột Quyền — nhóm biến thể **phân loại** của `Badge`.
 * Phân hệ là *loại*, không phải mức độ, nên một tông chung cho mọi phân hệ:
 * gán mỗi phân hệ một tông thành mười hai màu không ai đọc nổi.
 */
export const TONG_PHAN_HE: Extract<BadgeVariant, 'violet' | 'teal' | 'orange' | 'info'> = 'violet';

/**
 * Vai trò hệ thống — nhóm biến thể **phân loại**: nó là *loại* vai trò (seed
 * sẵn, không sửa được), không phải trạng thái khoẻ hay yếu. Dùng `success` ở
 * đây sẽ đọc thành "vai trò này đang tốt".
 */
export const TONG_HE_THONG: Extract<BadgeVariant, 'violet' | 'teal' | 'orange' | 'info'> = 'teal';

/**
 * Vai trò chưa có quyền nào — nhóm biến thể **trạng thái**: `warning` vì đó là
 * việc quản trị còn dở (gán vai trò này cho ai cũng không mở được gì).
 */
export const TONG_CHUA_CO_QUYEN: Extract<BadgeVariant, 'warning'> = 'warning';

/** Số nhãn phân hệ hiện trong một ô trước khi gộp thành `+n`. */
export const SO_PHAN_HE_HIEN = 3;

/** Cỡ trang khi nối hết danh sách: nền tảng có vài chục vai trò, một trang là hết. */
export const MOT_TRANG = 100;

export const KHOA_LOI_TEN: Record<LoiTenVaiTro, KhoaDich> = {
  trong: 'vaiTroNenTang.fTenTrong',
  dai: 'vaiTroNenTang.fQuaDai',
};

/**
 * Nhãn nhóm quyền trong ngăn phân quyền.
 *
 * Nhóm là mã `SCREAMING_CASE` do backend trả (ADR-0074 mục 2); bảng này đổi nó
 * thành khoá dịch. Nhóm lạ — backend thêm mã mới mà giao diện chưa biết — rơi
 * về chính mã đó, nên vẫn gom được chứ không mất hút.
 */
export const KHOA_NHAN_NHOM: Record<NhomQuyenNenTang, KhoaDich> = {
  TENANT: 'vaiTroNenTang.nhomTenant',
  GOI: 'vaiTroNenTang.nhomGoi',
  LICENSE: 'vaiTroNenTang.nhomLicense',
  VIEC: 'vaiTroNenTang.nhomViec',
  AUDIT: 'vaiTroNenTang.nhomAudit',
  CHINH_SACH: 'vaiTroNenTang.nhomChinhSach',
  BAO_MAT: 'vaiTroNenTang.nhomBaoMat',
  LIEN_HE: 'vaiTroNenTang.nhomLienHe',
  NHAN_SU: 'vaiTroNenTang.nhomNhanSu',
  VAI_TRO: 'vaiTroNenTang.nhomVaiTro',
  KHOA_API: 'vaiTroNenTang.nhomKhoaApi',
  MODEL_AI: 'vaiTroNenTang.nhomModelAi',
  MODULE: 'vaiTroNenTang.nhomModule',
};
